import { prettyNum, noop } from '@iqueue/ui-kit'
import { useMemo } from 'react'
import useTranslate, { t } from '../../hooks/useTranslate'

export const UNIT_PRESSURE = 'PRESSURE'
export const UNIT_TEMPERATURE = 'TEMPERATURE'
export const UNIT_VOLUME = 'VOLUME'
export const UNIT_TILT = 'TILT'

const UNIT_PRECISION = {
  [UNIT_TEMPERATURE]: 0,
  [UNIT_PRESSURE]: 0,
  [UNIT_VOLUME]: 2,
  [UNIT_TILT]: 1,
}

const CONVERSION_FUNCTIONS = {
  [UNIT_PRESSURE]: (value) => value * 10.197162,
  [UNIT_TEMPERATURE]: (value) => value,
  [UNIT_VOLUME]: (value) => value,
  [UNIT_TILT]: (value) => value * (180 / Math.PI),
}

const PRESSURE_UNITS = [
  'PRESSURE',
  'PRESSURE_INPUT',
  'PRESSURE_OUTPUT',
  'PRESSURE_WELL',
  'PRESSURE_PLUME',
]

export function humanizeMeasurement(value, unit) {
  if (PRESSURE_UNITS.includes(unit)) {
    unit = UNIT_PRESSURE
  }

  const convert = CONVERSION_FUNCTIONS[unit] || ((v) => '')

  if (!convert) {
    return { value, dimension: '' }
  }

  value = convert(value)

  let i = 0

  while (value > 100000) {
    value = value / 10000
    i++
  }

  return {
    value: prettyNum(value, 10, {
      delimiter: ' ',
      separator: '.',
      fixed: UNIT_PRECISION[unit],
    }),
    dimension: value ? ' ' + t(`dimension.${ unit }.humanize.${ i }`) : ' ',
  }
}

export function measurementToTitle(value, unit) {
  const { value: val, dimension } = humanizeMeasurement(value, unit)
  return `${ val } ${ dimension }`
}

export default function Measurement({ children, unit, prefix, postfix, ...props }) {
  const { locale } = useTranslate()
  const { value, dimension } = useMemo(() => {

    if (!children) {
      return { value: '0', dimension: '' }
    }

    noop(locale)
    return humanizeMeasurement(children, unit)
  }, [children, unit, locale])

  return <span { ...props } >
    { prefix }
    { value }
    <small className={ 'tiny' }>{ dimension }{ postfix }</small>
  </span>
}
